module.exports = __webpack_public_path__ + "img/imgbig-test.c21186a9.png";